import instance from "../root.api";

export const getCoursesRequest = (data) =>
  instance.get(`/courses`, data).then((response) => ({ response }));

export const submitAnswerRequest = ({ id, answers }) =>
  instance
    .post(`/exams/${id}/submit-answer`, { answers })
    .then((response) => ({ response }));
